export default "__VITE_ASSET__2qHmBZlw__"